// extracted by mini-css-extract-plugin
export default {"container":"home_container__BgDW7","title":"home_title__cojxH","subtitle":"home_subtitle__L1fXa","btn":"home_btn__hjnD5"};